import { ProvisionedDevice } from '@csp/csp-common-model';
import { ProvisionedDeviceV1 } from '@csp/dmdp-api-user-dto';

const from = (devices?: ProvisionedDeviceV1[]): ProvisionedDevice[] =>
  devices?.map(device => ({
    deviceId: device.deviceId,
    provisionedAtOrg: device.provisionedAtOrg,
    provisioningDate: device.provisioningDate,
    serialNumber: device.serialNumber,
    modifiedBy: device.modifiedBy,
    provisionedBy: device.provisionedBy,
  })) ?? [];

export const ProvisionedDeviceFactory = {
  from,
};
